module.exports = __webpack_public_path__ + "static/img/bg2.98b3d9e2.jpg";